import FlatEquationSolver from 'notebook/integrations/chemistry/custom-evals/stoichiometry-calculations/FlatEquationSolver';
import {
  STOICHIOMETRY_CALCULATION_EQUATIONS,
  StoichiometryVariable,
} from 'notebook/integrations/chemistry/custom-evals/stoichiometry-calculations/StoichiometryEquations';

const StoichiometrySolver = new FlatEquationSolver<StoichiometryVariable>(
  STOICHIOMETRY_CALCULATION_EQUATIONS
);

export type StoichiometryCalculationVariableValues = Partial<Record<StoichiometryVariable, number>>;

export default StoichiometrySolver;

/** The variables here cause circular dependencies when solving for them. */
export const STOICHIOMETRY_CALCULATION_CIRCULAR_VARIABLES = new Set([
  StoichiometryVariable.EQUIVALENCE,
  StoichiometryVariable.MOLS,
  StoichiometryVariable.AMOUNT,
]);

export const STOICHIOMETRY_CALCULATION_AVAILABLE_VARIABLES = Object.values(StoichiometryVariable).reduce<
  Record<StoichiometryVariable, boolean>
>(
  (acc, variable) => {
    acc[variable] = !STOICHIOMETRY_CALCULATION_CIRCULAR_VARIABLES.has(variable);
    return acc;
  },
  {} as Record<StoichiometryVariable, boolean>
);
